var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-header"},[_c('div',{staticClass:"row align-items-end"},[_c('div',{staticClass:"col-lg-12"},[_c('div',{staticClass:"page-header-title"},[_c('i',{class:'fa fa-'+_vm.icon+' bg-red'}),_c('div',{staticClass:"d-inline"},[_c('h5',[_vm._v(_vm._s(_vm.title))]),_c('span',[_vm._v(_vm._s(_vm.description))])])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }